import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";
import { useTaskStatusesRetrieval } from "@planzone/view-models";

function List(props: Props) {
  const { t } = useTranslation();
  return (
    <ul className={styles.list}>
      {props.statuses.map((status) => (
        <li
          key={status.uuid}
          className={styles.item}
          onClick={() => props.selectStatus(status)}
        >
          <div
            className={styles.square}
            style={{ backgroundColor: status.color }}
          />
          <span className={styles.paragraph} style={{ color: status.color }}>
            {t(`taskStatuses.${status.label}`, status.label)}{" "}
            {typeof status.percentComplete !== "undefined" &&
              status.percentComplete !== null &&
              `${status.percentComplete}%`}
          </span>
        </li>
      ))}
    </ul>
  );
}

export { List };
